import ProsthesisConfig from "@/views/configs/prosthesis/index.vue";
import ProsthesisTypeConfig from "@/views/configs/prosthesis/prosthesis_type.vue";
import ProsthesisManufacturerConfig from "@/views/configs/prosthesis/manufacturer.vue";
import ProsthesesConfig from "@/views/configs/prosthesis/prostheses.vue";

export default [
  {
    path: "proteses",
    name: "Config proteses",
    component: ProsthesisConfig,
    redirect: {
      path: "/configuracoes/proteses/modelos",
    },
    children: [
      {
        path: "modelos",
        name: "Config modelos proteses",
        component: ProsthesisTypeConfig,
      },
      {
        path: "fabricantes",
        name: "Config fabricantes proteses",
        component: ProsthesisManufacturerConfig,
      },
      {
        path: "proteses",
        name: "Config protese",
        component: ProsthesesConfig,
      },
    ],
  },
];
